module.exports = __webpack_public_path__ + "static/img/1.fa4a4d92.jpg";